import styled from '@emotion/styled';
import Button, { ButtonProps } from '@mui/material/Button';

const StyledLinkButton = styled(Button)`
  padding: 0;
  text-transform: none;
  font-family: 'PoppinsBold';
  font-size: inherit;

  &:hover {
    background-color: initial;
  }
`;

export const LinkButton = ({ children, ...props }: ButtonProps) => {
  return (
    <StyledLinkButton disableRipple variant='text' {...props}>
      {children}
    </StyledLinkButton>
  );
};
